import DevicePickerService from './device_picker_service.js';
import { KeyboardNavigation } from './keyboard_navigation.js';

const nav = new KeyboardNavigation({
   keys: {
      '/': deviceNavigator,
   },
});

export default function deviceNavigator(options = null) {
   if (!options) {
      options = {
         initialView: 'COLUMN',
      };
   }
   DevicePickerService.selectDevice(options).then(device => {
      if (device) {
         const encodedTitle = DevicePickerService.encodeDeviceTitle(device);
         window.location = `/Device/${encodedTitle}`;
      }
   });
}
